import React from 'react';
import { Target, TrendingUp, Shield, Lightbulb } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const WhyFintage = () => {
  const pillars = [
    {
      icon: Target,
      title: 'Industry Expertise',
      description: 'We bring an in-depth understanding of the challenges in MFI industry in the developing world',
      color: 'from-blue-50 to-blue-100'
    },
    {
      icon: TrendingUp,
      title: 'Scalability with Flexibility',
      description: 'Our cloud first approach provides a highly scalable solution without compromising in Customisability',
      color: 'from-cyan-50 to-cyan-100'
    },
    {
      icon: Shield,
      title: 'Security & Compliance',
      description: 'We prioritize data security with end-to-end encryption, compliance with global financial regulations, ensuring the highest level of trust and protection',
      color: 'from-blue-50 to-blue-100'
    },
    {
      icon: Lightbulb,
      title: 'Continuous Innovation',
      description: 'Our curious minds are always finding ways to do it faster, easier and better',
      color: 'from-cyan-50 to-cyan-100'
    }
  ];

  return (
    <section id="why-fintage" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Why Choose Fintage?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Delivering excellence through innovation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {pillars.map((pillar, index) => (
            <Card 
              key={index}
              className="group border-none shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden"
            >
              <CardContent className="p-6">
                <div className={`w-16 h-16 mx-auto mb-4 bg-gradient-to-br ${pillar.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <pillar.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900 text-center">
                  {pillar.title}
                </h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  {pillar.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button 
            size="lg"
            variant="outline"
            className="border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transition-colors duration-300"
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
          >
            Get in Touch
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyFintage;